var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.7853V12.5855C1 11.9863 1.2 11.2872 1.6 10.7878C2.2 10.1885 2.6 9.38954 2.8 8.49067C2.8 7.79154 2.8 7.19229 2.9 6.49316C3.2 3.19728 6.4 1.00003 9.5 1.00003H9.6C12.7 1.00003 15.9 3.19728 16.2 6.39329C16.3 7.09242 16.2 7.69167 16.2 8.39079C16.4 9.28967 16.8 10.0887 17.4 10.6879C17.8 11.1873 18 11.8864 18 12.4857V12.6854C18 13.5843 17.7 14.3833 17.2 15.0824C16.4 15.8814 15.4 16.3808 14.3 16.4807C11.1 16.7803 7.9 16.7803 4.7 16.4807C3.6 16.3808 2.6 15.8814 1.8 15.0824C1.3 14.4832 1 13.6842 1 12.7853Z",
    stroke: "#54B2DE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 19.8765C7.59961 20.4757 8.29961 20.8752 9.09961 20.9751C9.89961 21.075 10.6996 20.8752 11.3996 20.3758C11.5996 20.276 11.7996 20.0762 11.8996 19.8765",
    stroke: "#54B2DE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ae54ec3f199329b0f957f9ef442a5880.svg";
export { ForwardRef as ReactComponent };